import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.5 2.71741L1 5.92575V21.5001L6.5 19.2328V2.71741Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.5 18.9097L13.5 21.8625V21.6904C12.2673 20.5075 11.5 18.8434 11.5 17C11.5 15.1566 12.2673 13.4925 13.5 12.3096V5.09051L8.5 2.1377V18.9097Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 2.50012V11.2322C20.1025 10.7644 19.0821 10.5 18 10.5C17.1141 10.5 16.2696 10.6772 15.5 10.9982V4.76744L21 2.50012Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.8289 12.7573L18.0005 15.5857L15.172 12.7573L13.7578 14.1715L16.5862 17L13.7578 19.8284L15.172 21.2426L18.0005 18.4142L20.8289 21.2426L22.2431 19.8284L19.4147 17L22.2431 14.1715L20.8289 12.7573Z"}}]};

const MapCancelFilled = Vue.extend<IconProps>({
  name: 'MapCancelFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-cancel-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapCancelFilled;
